import { ia, iaRa } from 'lib/helpers/utility';

export const getAddressDisplay = (address) => {
  if (address && typeof address === 'object' && !ia(address)) {
    return address?.fullAddress;
  }

  if (address && typeof address !== 'number') {
    return address;
  }

  return null;
};

export const getAgingBreakdown = (invoices) => {
  const today = new Date();

  const aging = {
    'Current 0-30': 0,
    '31-60 Days': 0,
    '61-90 Days': 0,
    '91+ Days': 0
  };

  iaRa(invoices).forEach((invoice) => {
    if (!invoice?.dateofservice || !invoice?.total_amount) {
      return;
    }

    const invoiceDate = new Date(invoice.dateofservice);
    if (isNaN(invoiceDate.getTime())) {
      return;
    }

    const diffDays = Math.floor((today - invoiceDate) / (1000 * 60 * 60 * 24));
    const amount = Math.max(0, invoice.total_amount);
    if (diffDays <= 30) aging['Current 0-30'] += amount;
    else if (diffDays <= 60) aging['31-60 Days'] += amount;
    else if (diffDays <= 90) aging['61-90 Days'] += amount;
    else aging['91+ Days'] += amount;
  });

  return aging;
};
